<template>
    <div class="content-wrapper">
        <section class="content-header">
            <div class="row">
                <div class="col-xs-12">
                    <h1 class="pull-left">Free Sign Up PIN Report</h1>
                    <div class="pull-right">
                        <div class="btn-group" style="margin-top: 4px">
                            <button type="button" class="btn dropdown-toggle" data-toggle="dropdown"
                                style="background-color: #526883; color: white">
                                <i class="fa fa-download"></i> Download
                                <span class="caret"></span>
                            </button>
                            <ul class="dropdown-menu">
                                <li><a href="#" @click.prevent="downloadNow('pdf')">PDF</a></li>
                                <li><a href="#" @click.prevent="downloadNow('xlsx')">Excel (XLSX)</a></li>
                                <li><a href="#" @click.prevent="downloadNow('csv')">CSV</a></li>
                            </ul>
                        </div>
                        &nbsp;
                        <a href="#" class="btn" @click.prevent="refreshNow"
                            style="background-color: #526883; color: white">
                            <i class="fa fa-refresh"></i> Refresh
                        </a>
                    </div>
                </div>
            </div>
        </section>

        <section class="content">
            <form v-on:submit.prevent="searchReportData">
                <div class="row">
                    <div class="col-xs-6 col-sm-2">
                        <div class="form-group">
                            <filterDropdownOptions />
                        </div>
                    </div>
                    <div class="col-xs-6 col-sm-2 form-group">
                        <input placeholder="From" type="text" name="starttime" id="starttime" v-model="starttime"
                            autocomplete="off" class="form-control input-sm datePicker" />
                    </div>
                    <div class="col-xs-6 col-sm-2 form-group">
                        <input placeholder="To" type="text" name="stoptime" id="stoptime" v-model="stoptime"
                            autocomplete="off" class="form-control input-sm datePicker" />
                    </div>
                    <div class="col-xs-6 col-sm-2 form-group">
                        <input placeholder="Search By Username" type="text" v-model="login"
                            class="form-control input-sm" />
                    </div>
                    <div class="col-xs-6 col-sm-2 form-group">
                        <select name="social_status" id="social_status" v-model="social_status" v-select="social_status"
                            class="form-control input-sm select2" @change="searchReportData">
                            <option value="">All</option>
                            <option value="1">Include Social</option>
                            <option value="0">Exclude Social</option>
                        </select>
                    </div>
                    <div class="col-xs-6 col-sm-2 form-group">
                        <select v-model="display_limit" v-select="display_limit" class="form-control input-sm select2"
                            @change="dopagination(1)">
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="75">75</option>
                            <option value="100">100</option>
                            <option value="500">500</option>
                            <option value="1000">1000</option>
                        </select>
                    </div>

                    <div id="btnSearch" class="col-xs-6 col-sm-2 pull-right form-group btnLeft"
                        style="margin-bottom: 5px">
                        <button type="submit" class="btn btn-sm btn-submit pull-right">
                            <i class="fa fa-search"></i> Search
                        </button>
                    </div>
                </div>
            </form>

            <div class="row">
                <div class="col-md-12">
                    <div class="box" id="pagination">
                        <div class="box-header">
                            <h3 class="box-title">
                                Total : {{ totalData }} Showing {{ dispplayFrom }} to {{ dispplayTo }}
                                <span class="pull-right noOfData">{{ totalData }}</span>
                            </h3>
                        </div>
                        <div class="box-body">
                            <div class="table-responsive">
                                <table class="table table-0024 table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th class="tdCenter tdSN">SN</th>
                                            <th class="tdCenter">Username</th>
                                            <th class="tdCenter">Sign Up at</th>
                                            <th class="tdCenter">Onboarding Type</th>
                                            <th class="tdCenter">Last Login Country</th>
                                            <th class="tdCenter">Country From</th>
                                            <th class="tdCenter">Device Type</th>
                                            <th class="tdCenter">Model</th>
                                            <th class="tdCenter">OS</th>
                                            <th class="tdCenter">App Version</th>
                                            <th class="tdCenter">Last Login</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(data, index) in signupList" :key="data.id">
                                            <td class="tdCenter tdSN">{{ parseInt(sl) + index }}</td>
                                            <td>{{ removeHostedPinPrefixDynamic(data.username) }}</td>
                                            <td class="tdCenter">{{ formatDateTime(data.created_at) }}</td>
                                            <td class="tdCenter">
                                                <span :class="data.social_login_status == 1
                                                    ? 'label label-success'
                                                    : 'label label-primary'
                                                    ">
                                                    {{ data.social_login_status == 1 ? "Social" : "Non-Social" }}
                                                </span>
                                            </td>
                                            <td class="tdCenter">
                                                {{ data.pinlist && data.pinlist.last_login_country
                                                    ? data.pinlist.last_login_country : "-" }}
                                            </td>
                                            <td class="tdCenter">{{ data.country || "-" }}</td>
                                            <td class="tdCenter">
                                                {{ data.pinlist ? getDeviceTypeLabel(data.pinlist.device_type) : "-" }}
                                            </td>
                                            <td class="tdCenter">
                                                {{ data.pinlist && data.pinlist.model ? data.pinlist.model : "-" }}
                                            </td>
                                            <td class="tdCenter">
                                                <span v-if="data.pinlist && data.pinlist.os_name">
                                                    {{ data.pinlist.os_name }}
                                                    <small v-if="data.pinlist.os_version">({{ data.pinlist.os_version
                                                    }})</small>
                                                </span>
                                                <span v-else>-</span>
                                            </td>
                                            <td class="tdCenter">
                                                {{ data.pinlist && data.pinlist.vpn_app_version
                                                    ? data.pinlist.vpn_app_version : "-" }}
                                            </td>
                                            <td class="tdCenter">
                                                {{ data.pinlist && data.pinlist.last_login
                                                    ? formatDateTime(data.pinlist.last_login) : "-" }}
                                            </td>
                                        </tr>
                                        <tr v-if="totalData == 0">
                                            <td colspan="11" class="tdCenter" style="padding: 30px 0">
                                                <b>No Records Found</b>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div class="pagination" v-if="last_page > 1">
                            <a v-if="prev_page_url" href="#" @click="dopagination(prevPage)" class="next">
                                « Previous
                            </a>
                            <span v-else class="disabled">« Previous</span>

                            <span v-if="last_page > max_display_pagination">
                                <span v-for="index in last_page" :key="index">
                                    <span v-if="index == 1 || index == 2">
                                        <span class="current" v-if="index == current_page">{{ index }}</span>
                                        <span v-else><a href="#" @click="dopagination(index)">{{ index }}</a></span>
                                        <span v-if="index == 2 && firstDotted">..</span>
                                    </span>
                                    <span v-if="randomPageNumber.includes(index)">
                                        <span class="current" v-if="index == current_page">{{ index }}</span>
                                        <span v-else><a href="#" @click="dopagination(index)">{{ index }}</a></span>
                                    </span>
                                    <span v-if="index == last_page || index == last_page - 1">
                                        <span v-if="index == last_page - 1 && lastDotted">..</span>
                                        <span class="current" v-if="index == current_page">{{ index }}</span>
                                        <span v-else><a href="#" @click="dopagination(index)">{{ index }}</a></span>
                                    </span>
                                </span>
                            </span>
                            <span v-else>
                                <span v-for="index in last_page" :key="index">
                                    <span class="current" v-if="index == current_page">{{ index }}</span>
                                    <span v-else><a href="#" @click="dopagination(index)">{{ index }}</a></span>
                                </span>
                            </span>

                            <a v-if="next_page_url" href="#" @click="dopagination(nextPage)" class="next">
                                Next »
                            </a>
                            <span v-else class="disabled">Next »</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import filterDropdownOptions from "@/components/common/filterDropdownOptions.vue";
import axios from "axios";

export default {
    name: "FreeSignupPinsReport",
    components: { filterDropdownOptions },
    data() {
        return {
            signupList: [],
            sl: 1,
            dispplayFrom: 0,
            dispplayTo: 0,
            display_limit: 50,
            totalData: 0,
            prev_page_url: false,
            next_page_url: false,
            last_page: 1,
            current_page: null,
            max_display_pagination: 9,
            randomPageNumber: [],
            firstDotted: false,
            lastDotted: false,
            prevPage: "",
            nextPage: "",

            // filters
            starttime: "",
            stoptime: "",
            login: "",
            social_status: "",

            deviceTypeMap: {
                1: "Android",
                2: "iOS",
                3: "Windows",
                4: "Mac",
                10: "Reseller Panel",
            },
        };
    },
    created() {
        this.com_free_signup_pin_report(this.userData.reseller.id);
        this.filterWiseDateRangeSet();
        this.searchReportData();
    },
    mounted() {
        const rootObject = this;

        $("#starttime")
            .datetimepicker({ timepicker: false, format: "Y-m-d" })
            .on("change", function () {
                rootObject.starttime = $(this).val();
            });

        $("#stoptime")
            .datetimepicker({ timepicker: false, format: "Y-m-d" })
            .on("change", function () {
                rootObject.stoptime = $(this).val();
            });

        $("#short_filter").on("change", function () {
            rootObject.filterWiseDateRangeSet();
            rootObject.searchReportData();
        });

        $(".select2").select2();

        // Now that pickers are ready, set initial dates and fetch data
        this.filterWiseDateRangeSet();
        this.searchReportData();
    },

    filterWiseDateRangeSet() {
        $(".datePicker").removeAttr("readonly");
        if ($("#short_filter").val()) {
            this.starttime = "";
            this.stoptime = "";
            $("#starttime").val("");
            $("#stoptime").val("");
            $(".datePicker").attr("readonly", "readonly");
        } else {
            const today = this.getFormattedDate();
            this.starttime = today;
            this.stoptime = today;
            // Sync the jQuery input values too — v-model alone doesn't update jQuery widgets
            $("#starttime").val(today);
            $("#stoptime").val(today);
        }
    },
    methods: {
        ifNotAdminRedirect() {
            this.$router.push({ name: "Dashboard" });
        },
        removeHostedPinPrefixDynamic(actualPin, prefix = false) {
            if (!actualPin) return actualPin;

            let trimPin = actualPin;

            if (prefix) {
                const newPin = actualPin.replace(prefix, "");
                trimPin = newPin.charAt(0) === "-" ? newPin.substring(1) : newPin;
            } else {
                const getHR4Pos = actualPin.indexOf("HR4");
                if (getHR4Pos !== -1) {
                    const getHyphenPos = actualPin.indexOf("-");
                    if (getHyphenPos > 0) {
                        trimPin = actualPin.substring(getHyphenPos + 1);
                    }
                }
            }

            return trimPin;
        },
        formatDateTime(dt) {
            if (!dt) return "-";
            const d = new Date(dt);
            const pad = (n) => String(n).padStart(2, "0");
            return (
                `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
                `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
            );
        },

        getDeviceTypeLabel(type) {
            return this.deviceTypeMap[type] || "-";
        },

        filterWiseDateRangeSet() {
            $(".datePicker").removeAttr("readonly");
            if ($("#short_filter").val()) {
                this.starttime = "";
                this.stoptime = "";
                $(".datePicker").attr("readonly", "readonly");
            } else {
                const today = this.getFormattedDate();
                this.starttime = today;
                this.stoptime = today;
            }
        },

        getFormattedDate() {
            const today = new Date();
            const pad = (n) => String(n).padStart(2, "0");
            return `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`;
        },

        buildParams(page) {
            return {
                paginate: this.display_limit,
                from_date: this.starttime,
                to_date: this.stoptime,
                login: this.login,
                social_status: this.social_status,
                short_filter: $("#short_filter").val() || "",
                page: page > 0 ? page : 1,
            };
        },

        searchReportData() {
            this.dopagination(1);
        },

        dopagination(page_no = 1) {
            loader.show();
            const rootObject = this;

            axios
                .get("/free-signup-pins", { params: this.buildParams(page_no) })
                .then(function (response) {
                    rootObject.populateData(response.data);
                    loader.hide();
                })
                .catch(function (error) {
                    loader.hide();
                    rootObject.com_errorHandel(error);
                });
        },

        populateData(response) {
            this.signupList = response.data || [];
            const p = response.pagination || {};
            this.sl = parseInt(p.from || 1);
            this.totalData = p.total || 0;
            this.dispplayFrom = p.from || 0;
            this.dispplayTo = p.to || 0;
            this.display_limit = p.per_page || this.display_limit;

            this.prev_page_url = p.prev_page_url;
            this.next_page_url = p.next_page_url;
            this.last_page = p.last_page || 1;
            this.current_page = p.current_page || 1;
            this.prevPage = this.current_page - 1;
            this.nextPage = this.current_page + 1;

            this.generatePageNumbers();
        },

        generatePageNumbers() {
            this.randomPageNumber = [];
            this.firstDotted = false;
            this.lastDotted = false;
            const countableOtherPages = this.max_display_pagination - 4;

            if (this.current_page == 1 || this.current_page == 2) {
                for (let i = 3; i <= 3 + (countableOtherPages - 1); i++) this.randomPageNumber.push(i);
                this.lastDotted = true;
            } else if (this.current_page == this.last_page || this.current_page == this.last_page - 1) {
                const endPage = this.last_page - 2;
                for (let i = endPage; i >= endPage - (countableOtherPages - 1); i--) this.randomPageNumber.push(i);
                this.firstDotted = true;
            } else {
                const interval = parseInt(countableOtherPages / 2);
                if (this.current_page <= interval + 3) {
                    for (let i = 3; i <= 3 + (countableOtherPages - 1); i++) this.randomPageNumber.push(i);
                    this.lastDotted = true;
                } else if (this.current_page >= this.last_page - (interval + 2)) {
                    const endPage = this.last_page - 2;
                    for (let i = endPage; i >= endPage - (countableOtherPages - 1); i--) this.randomPageNumber.push(i);
                    this.firstDotted = true;
                } else {
                    for (let i = this.current_page; i <= this.current_page + interval; i++) this.randomPageNumber.push(i);
                    for (let i = this.current_page - 1; i >= this.current_page - interval; i--) this.randomPageNumber.push(i);
                }
            }
        },

        downloadNow(format) {
            loader.show();
            const rootObject = this;

            const params = {
                ...this.buildParams(1),
                format: format,
            };

            axios
                .get("/free-signup-pins-download", {
                    params: params,
                    responseType: "blob",
                })
                .then(function (response) {
                    const blob = new Blob([response.data], {
                        type: response.headers["content-type"],
                    });
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    const fileName = "free_signup_pins_report_" + rootObject.getFormattedTime() + "." + format;
                    a.download = fileName;
                    document.body.append(a);
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);
                    loader.hide();
                })
                .catch(function (error) {
                    loader.hide();
                    rootObject.com_errorHandel(error);
                });
        },

        getFormattedTime() {
            const today = new Date();
            return (
                today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate()
            );
        },

        refreshNow() {
            this.login = "";
            this.social_status = "";
            this.display_limit = 50;
            $("#short_filter").val("").trigger("change");
            this.filterWiseDateRangeSet();
            this.searchReportData();
        },
    },
};
</script>

<style scoped></style>